import React from "react";
import { HeadingParagraph } from "./HeadingParagraph";

export default function RefundPolicyContentComponent() {
  return (
    <>
      <HeadingParagraph
        heading={"REFUND REQUESTS"}
        paragraphs={[
          "Our Website does not entertain any refund requests. Once a payment has been made by a User, and they choose not to participate for whatever reason, no amount of the payment will be refunded.",
          "All payments are made via payment gateways, Users are advised to read all information carefully before making a payment. We will not be held liable for any payment discrepancies.",
        ]}
      />
      <HeadingParagraph
        heading={"CANCELLATION REQUESTS"}
        paragraphs={[
          "Our Website does not entertain any cancellation requests. Users can choose not to participate but we do not have any provision for cancellation of a participant.",
          "We maintain a negative list of all fraudulent transactions and non-complying users and reserve the right to deny access to such users at any time or cancel any orders placed by them in future.",
        ]}
      />
    </>
  );
}
